import { render, staticRenderFns } from "./MCart.vue?vue&type=template&id=5795e246&scoped=true"
import script from "./MCart.vue?vue&type=script&lang=js"
export * from "./MCart.vue?vue&type=script&lang=js"
import style0 from "./MCart.vue?vue&type=style&index=0&id=5795e246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795e246",
  null
  
)

export default component.exports